import React from "react";
import { AtomicLogoProps } from "../../types/types";

const AtomicLogo: React.FC<AtomicLogoProps> = (
  props: AtomicLogoProps,
  // ...rest
) => {
  const {
    logoSrc,
    altText,
    containerStyle = {},
    imageStyle = {},
    className,
  } = props;

  return (
    <div style={containerStyle}>
      <img
        src={logoSrc}
        alt={altText}
        style={imageStyle}
        className={className}
        // {...rest}
      />
    </div>
  );
};

export default AtomicLogo;
